import React, { useState } from 'react'
import { leftShownStatus, useOverlay } from '../../contexts/OverlayContext';
import { VARIABLE_COLOR } from '../../constants/constants';
import { useStore } from '../../store/store';
import { useEditor } from '../../contexts/EditorContext';
import { variableSupportsLineStyle } from '../RightSide/variablesUtils';

const VariableDecorator = (props) => {
  const { updateLeftShownStatus } = useOverlay();
  const handleBoxVariableSelectedId = useStore(({ handleBoxVariableSelectedId }) => handleBoxVariableSelectedId)
  const selectVariableOccurrence = useStore(({ selectVariableOccurrence }) => selectVariableOccurrence)
  // Absent des éditeurs hors box du document (titres, aperçus du formulaire) :
  // l'occurrence n'y est alors pas traçable, le réglage d'affichage ne s'affiche pas.
  const { boxId } = useEditor()
  // Édition rapide (panel droit) : en template, seul endroit où Nom/Groupe
  // lié/Remarques de la variable sont éditables (cf. FormCustomText). En
  // proposition, le clic n'ouvre que le réglage d'affichage des variables
  // multi-lignes (adresse), les autres restent de simples morceaux de texte.
  const isTemplate = useStore(({ currentDocument }) => currentDocument.type === 'template')
  const [isHovered, setIsHovered] = useState(false)

  const getVariableKey = () => {
    const entity = props.contentState.getEntity(props.entityKey);
    return entity.getData().key;
  }

  return (
    <span
      data-offset-key={props.offsetkey}
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={
        {
          backgroundColor: 'transparent',
          ...(isHovered && {
            color: "#fff",
            backgroundColor: `${VARIABLE_COLOR}c7`,
            ...(isTemplate && { cursor: 'pointer' })
          })
        }}
      onClick={(e) => {
        const variableKey = getVariableKey()
        if (!isTemplate && !variableSupportsLineStyle(variableKey, useStore.getState().variables[variableKey]?.value)) return;
        e.stopPropagation();
        e.preventDefault();
        handleBoxVariableSelectedId(variableKey)
        // Après handleBoxVariableSelectedId, qui périme l'occurrence précédente.
        if (boxId) selectVariableOccurrence({ boxId, entityKey: props.entityKey, variableKey })
      }}
      onDoubleClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        updateLeftShownStatus(leftShownStatus["VARIABLES"], getVariableKey())
      }}
    >
      {props.children}
    </span>
  );
};

export default VariableDecorator
